import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';

import { FooterOverlay, Newsletter } from '../../components';
import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer" id="login">
    <FooterOverlay />
    <Newsletter />
    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">120 West MacArthur St Shawnee, OK 74804, United States</p>
        <p className="p__opensans">+1 405-275-5650</p>
      </div>

      <div className="app__footer-links_logo">
        <img src={images.pauls_place} alt="footer_logo" />
        <p className="p__opensans">&quot;The best way to find yourself is to lose yourself in the service of others.&quot;</p>
        <img src={images.spoon} className="spoon__img" alt='spoon img' style={{ marginTop: 15 }} />
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <a href="https://www.instagram.com/paulsplacesteakhouse/">
            <FiInstagram />
          </a>
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Tuesday-Saturday:</p>
        <p className="p__opensans">11:00 am - 08:30 pm</p>
        <p className="p__opensans">Closed Sunday - Monday</p>
      </div>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">2022 Paul's Place Steak House. All Rights reserved.</p>
    </div>

  </div>
);

export default Footer;
